import React from "react";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { QUOTE_STEPS, FULL_QUOTE_STEPS, PATHS, BRAND_NAME, APP_CONFIG } from "../AppConstants";
import { IAppState, ICarrierCustomization } from "../state/interfaces";
import { connect } from "react-redux";
import Utilities from "../classes/Utilities";
import { getPortalSettings } from "../config/portalSettings";

interface IProps extends RouteComponentProps {
    vehicleIndex: number,
    goBackVisible: boolean,
    carrierCustomization?: ICarrierCustomization | null | undefined,
    className?: string;
}

class Header extends React.Component<IProps, any> {

    constructor(props: IProps) {
        super(props);
    }

    goBack(e : any) {
        e.preventDefault();
        if (this.props.history.location.pathname === Utilities.formatUrl(PATHS.QUICK, "")
            || this.props.history.location.pathname === Utilities.formatUrl(PATHS.QUICK_VEHICLE, "")) {
            this.props.history.push(PATHS.CHANGE_ZIP);
        }
        else {
            this.props.history.goBack();
        }
    }

    componentDidMount() {
    }

    render() {
        const settings = getPortalSettings();
        const brandName = settings.brandName || BRAND_NAME;
        const logoUrl = this.props.carrierCustomization?.logoUrl || APP_CONFIG.BRAND_LOGO_URL;
        const brandHomeUrl = settings.brandHomeUrl;
        const img = <img className="site-logo" src={logoUrl} alt={brandName} />;
        const brandContent = brandHomeUrl
            ? <a href={brandHomeUrl} target="_blank" rel="noopener noreferrer">{img}</a>
            : img;

        return (
            <div className={"header" + (this.props.className ? this.props.className : "")}>
                <div className="header-nav">
                    <a href="" className="back-btn" onClick={(e: any) => this.goBack(e)} style={{ display: this.props.goBackVisible ? "" : "none" }}><i className="fas fa-chevron-left"></i></a>
                    <div className="text-center brand">
                        {brandContent}
                    </div>
                </div>
            </div>
        );
    }
}

let mapProps = (state: IAppState, ownProps: any) => {
    var vehicleIndex = !ownProps.match.params["vehicleIndex"]
        ? 0
        : parseInt(ownProps.match.params["vehicleIndex"], 10);

    var goBackVisible = !!state.currentStep
        && (state.currentStep !== QUOTE_STEPS.START
            && state.currentStep !== QUOTE_STEPS.QUICK_ZIP
            && state.currentStep !== QUOTE_STEPS.CHANGE_ZIP
            && state.currentStep !== FULL_QUOTE_STEPS.FINISH
            && state.currentStep !== QUOTE_STEPS.RTR_COVERAGES
            && state.currentStep !== QUOTE_STEPS.SUB_COVERAGES);

    if (state.quoteFromLiberate && state.currentStep === QUOTE_STEPS.YOUR_HOME)
    {
        goBackVisible = false;
    }

    return {
        vehicleIndex,
        carrierCustomization: state.carrierCustomization,
        goBackVisible: goBackVisible
    }
}

let mapDispatch = (dispatch: any) => {
    return {
    }
}

export default withRouter(connect(mapProps)(Header))
